var _rect, _path, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 4296",
    d: "M-1925.16 682.562C-1932.34 671.832 -1937.5 659.636 -1940.1 646.516L-1935.19 645.546C-1936.38 639.552 -1937 633.351 -1937 627V602.584H-1942V553.75H-1937V504.917H-1942V456.084H-1937V407.25H-1942V358.417H-1937V309.583H-1942V260.75H-1937V211.917H-1942V163.083H-1937V114.25H-1942V65.4166H-1937V16.5833H-1942V-32.2501H-1937V-81.0835H-1942V-129.917H-1937V-178.75H-1942V-227.583H-1937V-276.417H-1942V-325.25H-1937V-374.083H-1942V-422.917H-1937V-471.75H-1942V-520.583H-1937V-569.417H-1942V-618.25H-1937V-667.083H-1942V-715.917H-1937V-764.75H-1942V-813.583H-1937V-862.417H-1942V-911.25H-1937V-960.083H-1942V-1008.92H-1937V-1057.75H-1942V-1106.58H-1937V-1131C-1937 -1137.35 -1936.38 -1143.55 -1935.19 -1149.55L-1940.1 -1150.52C-1937.5 -1163.64 -1932.34 -1175.83 -1925.16 -1186.56L-1921 -1183.78C-1914.06 -1194.14 -1905.14 -1203.06 -1894.78 -1210L-1897.56 -1214.16C-1886.83 -1221.34 -1874.64 -1226.5 -1861.52 -1229.1L-1860.55 -1224.19C-1854.55 -1225.38 -1848.35 -1226 -1842 -1226H-1818.23V-1231H-1770.69V-1226H-1723.15V-1231H-1675.61V-1226H-1628.06V-1231H-1580.52V-1226H-1532.98V-1231H-1485.44V-1226H-1437.9V-1231H-1390.36V-1226H-1342.81V-1231H-1295.27V-1226H-1247.73V-1231H-1200.19V-1226H-1152.65V-1231H-1105.1V-1226H-1057.56V-1231H-1010.02V-1226H-962.479V-1231H-914.938V-1226H-867.396V-1231H-819.854V-1226H-772.312V-1231H-724.771V-1226H-677.229V-1231H-629.687V-1226H-582.145V-1231H-534.603V-1226H-487.062V-1231H-439.52V-1226H-391.979V-1231H-344.437V-1226H-296.895V-1231H-249.354V-1226H-201.812V-1231H-154.27V-1226H-106.729V-1231H-59.1871V-1226H-11.6455V-1231H35.8961V-1226H83.4377V-1231H130.979V-1226H178.521V-1231H226.063V-1226H273.604V-1231H321.146V-1226H368.688V-1231H416.229V-1226H463.771V-1231H511.312V-1226H558.854V-1231H606.396V-1226H653.937V-1231H701.479V-1226H749.021V-1231H796.562V-1226H844.104V-1231H891.646V-1226H939.188V-1231H986.729V-1226H1034.27V-1231H1081.81V-1226H1129.35V-1231H1176.9V-1226H1224.44V-1231H1271.98V-1226H1319.52V-1231H1367.06V-1226H1414.6V-1231H1462.15V-1226H1509.69V-1231H1557.23V-1226H1581C1587.35 -1226 1593.55 -1225.38 1599.55 -1224.19L1600.52 -1229.1C1613.64 -1226.5 1625.83 -1221.34 1636.56 -1214.16L1633.78 -1210C1644.14 -1203.06 1653.06 -1194.14 1660 -1183.78L1664.16 -1186.56C1671.34 -1175.83 1676.5 -1163.64 1679.1 -1150.52L1674.19 -1149.55C1675.38 -1143.55 1676 -1137.35 1676 -1131V-1106.58H1681V-1057.75H1676V-1008.92H1681V-960.084H1676V-911.25H1681V-862.417H1676V-813.583H1681V-764.75H1676V-715.917H1681V-667.083H1676V-618.25H1681V-569.417H1676V-520.583H1681V-471.75H1676V-422.917H1681V-374.083H1676V-325.25H1681V-276.416H1676V-227.583H1681V-178.75H1676V-129.917H1681V-81.0833H1676V-32.25H1681V16.5834H1676V65.4166H1681V114.25H1676V163.083H1681V211.917H1676V260.75H1681V309.583H1676V358.417H1681V407.25H1676V456.083H1681V504.917H1676V553.75H1681V602.583H1676V627C1676 633.351 1675.38 639.552 1674.19 645.546L1679.1 646.516C1676.5 659.636 1671.34 671.832 1664.16 682.562L1660 679.78C1653.06 690.142 1644.14 699.064 1633.78 706.002L1636.56 710.156C1625.83 717.339 1613.64 722.501 1600.52 725.097L1599.55 720.192C1593.55 721.377 1587.35 722 1581 722H1557.23V727H1509.69V722H1462.15V727H1414.61V722H1367.06V727H1319.52V722H1271.98V727H1224.44V722H1176.9V727H1129.35V722H1081.81V727H1034.27V722H986.73V727H939.188V722H891.646V727H844.104V722H796.563V727H749.021V722H701.479V727H653.938V722H606.396V727H558.854V722H511.312V727H463.771V722H416.229V727H368.687V722H321.145V727H273.604V722H226.062V727H178.52V722H130.979V727H83.4369V722H35.8951V727H-11.6464V722H-59.188V727H-106.73V722H-154.271V727H-201.813V722H-249.355V727H-296.896V722H-344.438V727H-391.979V722H-439.521V727H-487.063V722H-534.604V727H-582.146V722H-629.688V727H-677.229V722H-724.771V727H-772.312V722H-819.854V727H-867.396V722H-914.937V727H-962.479V722H-1010.02V727H-1057.56V722H-1105.1V727H-1152.65V722H-1200.19V727H-1247.73V722H-1295.27V727H-1342.81V722H-1390.35V727H-1437.9V722H-1485.44V727H-1532.98V722H-1580.52V727H-1628.06V722H-1675.6V727H-1723.15V722H-1770.69V727H-1818.23V722H-1842C-1848.35 722 -1854.55 721.377 -1860.55 720.192L-1861.52 725.097C-1874.64 722.501 -1886.83 717.339 -1897.56 710.156L-1894.78 706.002C-1905.14 699.064 -1914.06 690.142 -1921 679.78L-1925.16 682.562Z",
    stroke: "black",
    strokeWidth: 10,
    strokeDasharray: "48 48"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "User Defined specific skills",
    clipPath: "url(#clip0_654_26898)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 1206,
    transform: "translate(-289 -848)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Left"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main section"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Main section_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Agent details"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 625956"
  }, /*#__PURE__*/React.createElement("g", {
    id: "con"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Define skills",
    filter: "url(#filter0_d_654_26898)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_654_26898",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-133 -149C-133 -151.209 -131.209 -153 -129 -153H872C874.209 -153 876 -151.209 876 -149V75C876 77.2091 874.209 79 872 79H-129C-131.209 79 -133 77.2091 -133 75V-149Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-133 -149C-133 -151.209 -131.209 -153 -129 -153H872C874.209 -153 876 -151.209 876 -149V75C876 77.2091 874.209 79 872 79H-129C-131.209 79 -133 77.2091 -133 75V-149Z",
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-139 -149C-139 -151.761 -136.761 -154 -134 -154H872C874.761 -154 877 -151.761 877 -149H875C875 -150.657 873.657 -152 872 -152H-127C-127 -152 -127 -150.657 -127 -149H-139ZM877 75C877 77.7614 874.761 80 872 80H-134C-136.761 80 -139 77.7614 -139 75H-127C-127 76.6569 -127 78 -127 78H872C873.657 78 875 76.6569 875 75H877ZM-134 80C-136.761 80 -139 77.7614 -139 75V-149C-139 -151.761 -136.761 -154 -134 -154L-127 -152C-127 -152 -127 -150.657 -127 -149V75C-127 76.6569 -127 78 -127 78L-134 80ZM872 -154C874.761 -154 877 -151.761 877 -149V75C877 77.7614 874.761 80 872 80V78C873.657 78 875 76.6569 875 75V-149C875 -150.657 873.657 -152 872 -152V-154Z",
    fill: "url(#paint0_linear_654_26898)",
    mask: "url(#path-2-inside-1_654_26898)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Frame 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 625980",
    filter: "url(#filter1_d_654_26898)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 625972"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 625973"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Agent instructions"
  }, /*#__PURE__*/React.createElement("g", {
    id: "System message"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 625959"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 625970"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Choice token"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -67,
    y: 7,
    width: 75,
    height: 24,
    rx: 4,
    fill: "#3F3F3F"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Unshare"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "bg",
    cx: 7.5,
    cy: 7.5,
    r: 7,
    fill: "#F2F2F2",
    stroke: "#3F3F3F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "unshare",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91499 3.91469C3.695 4.13468 3.695 4.49135 3.91499 4.71134L6.70382 7.50012L3.91587 10.288C3.69587 10.508 3.69587 10.8647 3.91587 11.0847C4.13586 11.3047 4.49254 11.3047 4.71253 11.0847L7.50048 8.29678L10.2883 11.0845C10.5083 11.3045 10.865 11.3045 11.085 11.0845C11.305 10.8646 11.305 10.5079 11.085 10.2879L8.29715 7.50012L11.0858 4.71148C11.3058 4.49149 11.3058 4.13482 11.0858 3.91483C10.8658 3.69484 10.5092 3.69484 10.2892 3.91483L7.50048 6.70347L4.71166 3.91469C4.49167 3.6947 4.13499 3.6947 3.91499 3.91469Z",
    fill: "#3F3F3F"
  })))))))))))))))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "If user wants to Add Dataset"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M-4089 -330.5L-4102.27 -336.66C-4102.99 -337.074 -4104 -336.489 -4104 -335.66V-322.34C-4104 -321.511 -4102.99 -320.926 -4102.27 -321.34L-4089 -327.5V-330.5ZM-1265.06 1800.5C-1264.24 1800.5 -1263.56 1799.83 -1263.56 1799C-1263.56 1798.17 -1264.24 1797.5 -1265.06 1797.5V1800.5ZM-393.064 1797.5C-393.893 1797.5 -394.564 1798.17 -394.564 1799C-394.564 1799.83 -393.893 1800.5 -393.064 1800.5V1797.5ZM2242.06 1800.06C2242.65 1799.47 2242.65 1798.53 2242.06 1797.94L2232.51 1788.39C2231.93 1787.81 2230.98 1787.81 2230.39 1788.39C2229.81 1788.98 2229.81 1789.93 2230.39 1790.51L2238.88 1799L2230.39 1807.49C2229.81 1808.07 2229.81 1809.02 2230.39 1809.61C2230.98 1810.19 2231.93 1810.19 2232.51 1809.61L2242.06 1800.06ZM-4090.5 -327.5H-3676V-330.5H-4090.5V-327.5ZM-3653.5 -305V1775H-3650.5V-305H-3653.5ZM-3628 1800.5H-1265.06V1797.5H-3628V1800.5ZM-393.064 1800.5H2241V1797.5H-393.064V1800.5ZM-3653.5 1775C-3653.5 1789.08 -3642.08 1800.5 -3628 1800.5V1797.5C-3640.43 1797.5 -3650.5 1787.43 -3650.5 1775H-3653.5ZM-3676 -327.5C-3663.57 -327.5 -3653.5 -317.426 -3653.5 -305H-3650.5C-3650.5 -319.083 -3661.92 -330.5 -3676 -330.5V-327.5Z",
    fill: "#4097FD"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "If user wants to share Agent"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_2",
    d: "M-4089 -330.5L-4102.27 -336.66C-4102.99 -337.074 -4104 -336.489 -4104 -335.66V-322.34C-4104 -321.511 -4102.99 -320.926 -4102.27 -321.34L-4089 -327.5V-330.5ZM4142.76 7039.5C4143.59 7039.5 4144.26 7038.83 4144.26 7038C4144.26 7037.17 4143.59 7036.5 4142.76 7036.5V7039.5ZM5008.76 7036.5C5007.94 7036.5 5007.26 7037.17 5007.26 7038C5007.26 7038.83 5007.94 7039.5 5008.76 7039.5V7036.5ZM13715.6 465.939C13715 465.354 13714 465.354 13713.4 465.939L13703.9 475.485C13703.3 476.071 13703.3 477.021 13703.9 477.607C13704.5 478.192 13705.4 478.192 13706 477.607L13714.5 469.121L13723 477.607C13723.6 478.192 13724.5 478.192 13725.1 477.607C13725.7 477.021 13725.7 476.071 13725.1 475.485L13715.6 465.939ZM-4090.5 -327.5H-3853V-330.5H-4090.5V-327.5ZM-3830.5 -305V7014H-3827.5V-305H-3830.5ZM-3805 7039.5H4142.76V7036.5H-3805V7039.5ZM5008.76 7039.5H13690.5V7036.5H5008.76V7039.5ZM13716 7014V467H13713V7014H13716ZM13690.5 7039.5C13704.6 7039.5 13716 7028.08 13716 7014H13713C13713 7026.43 13702.9 7036.5 13690.5 7036.5V7039.5ZM-3830.5 7014C-3830.5 7028.08 -3819.08 7039.5 -3805 7039.5V7036.5C-3817.43 7036.5 -3827.5 7026.43 -3827.5 7014H-3830.5ZM-3853 -327.5C-3840.57 -327.5 -3830.5 -317.426 -3830.5 -305H-3827.5C-3827.5 -319.083 -3838.92 -330.5 -3853 -330.5V-327.5Z",
    fill: "#4097FD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_654_26898",
    x: -144,
    y: -160,
    width: 1031,
    height: 254,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_654_26898"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_654_26898",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_654_26898",
    x: -141,
    y: -25,
    width: 1025,
    height: 77,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_654_26898"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_654_26898",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_654_26898",
    x1: 371.5,
    y1: -153,
    x2: 371.5,
    y2: 79,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#95A5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_654_26898"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 1206,
    fill: "white",
    transform: "translate(-289 -848)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancelIcon.716a9fa581c3f001bcbbd76fd64e24d0.svg";
export { ForwardRef as ReactComponent };